import { render, staticRenderFns } from "./WalletItem.vue?vue&type=template&id=6e79036e&scoped=true&"
import script from "./WalletItem.vue?vue&type=script&lang=ts&"
export * from "./WalletItem.vue?vue&type=script&lang=ts&"
import style0 from "./WalletItem.vue?vue&type=style&index=0&id=6e79036e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79036e",
  null
  
)

export default component.exports